import { createError } from '../utils/background/general';
import { proto } from '../proto/ListenerProto';

interface MainConnectionErrorParams {
    status?: number;
    metainfo?: string | number | boolean | null | undefined | object;
    message?: string;
    extra?: string | number | boolean | null | undefined | object;
}

const AlreadyStartedError = createError({
    name: 'AlreadyStartedError',
    message: 'Main connection already started'
});

// Default Internal Error
const InternalError = createError({
    name: 'InternalErrorDefault',
    message: (p: MainConnectionErrorParams) => `Daemon internal error — ${proto.Status[p.status ?? 0]}`,
    fingerprint: (p: MainConnectionErrorParams) => [p.metainfo]
});

// Default Invalid Request Error
const InvalidRequestError = createError({
    name: 'InvalidRequestErrorDefault',
    message: (p: MainConnectionErrorParams) => `Daemon invalid request — ${proto.Status[p.status ?? 0]}`,
    fingerprint: (p: MainConnectionErrorParams) => [p.metainfo]
});

export const ListenerRequestError = createError({
    name: 'ListenerRequestError',
    message: (p: MainConnectionErrorParams) => `Daemon request error - Status: ${proto.Status[p.status ?? 0]} - ${p.message}`,
    fingerprint: (p: MainConnectionErrorParams) => [p.metainfo]
});

export const EmptyDeviceList = createError({
    name: 'EmptyDeviceList',
    message: (p: MainConnectionErrorParams) => `Daemon request error - Status: ${proto.Status[p.status ?? 0]} - ${p.message}`,
    fingerprint: (p: MainConnectionErrorParams) => [p.metainfo]
});

export const StartMixedRecordingRequestFail = createError({
    name: 'StartMixedRecordingRequestFail',
    message: (p: MainConnectionErrorParams) => `Daemon request error - Status: ${proto.Status[p.status ?? 0]} - ${p.message}`,
    fingerprint: (p: MainConnectionErrorParams) => [p.metainfo]
});

export const EventBroadcasterRequestTimedOut = createError({
    name: 'EventBroadcasterRequestTimedOut',
    message: (p: MainConnectionErrorParams) => `Daemon request error - Status: ${proto.Status[p.status ?? 0]} - ${p.message}`,
    fingerprint: (p: MainConnectionErrorParams) => [p.metainfo]
});

export const DeviceListRequestFail = createError({
    name: 'EventBroadcasterRequestFail',
    message: (p: MainConnectionErrorParams) => `Daemon request error - Status: ${proto.Status[p.status ?? 0]} - ${p.message}`,
    fingerprint: (p: MainConnectionErrorParams) => [p.metainfo]
});

export const MainConn = {
    AlreadyStartedError,
    InternalError,
    InvalidRequestError
};
